import { render, staticRenderFns } from "./PlanejamentoAcaoFormComportamento.vue?vue&type=template&id=3c621cb6&"
import script from "./PlanejamentoAcaoFormComportamento.vue?vue&type=script&lang=js&"
export * from "./PlanejamentoAcaoFormComportamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
